/* global $ */

(function (scope) {
  "use strict";

  /**
   *
   */
  var PrintMarketplaceThumbnailView = (scope.PrintMarketplaceThumbnailView =
    function (controller, design) {
      this.controller = controller;
      this.design = design;

      this.$el = $("#PrintMarketplaceThumbnailView");
      this.$el.on(
        "click",
        ".marketplace-thumbnail-item",
        this.toggleImageViewer.bind(this)
      );

      //only there is a printMarketPlaceThumbnail
      if (this.$el.length > 0) {
        this.init();
      }
    });

  PrintMarketplaceThumbnailView.prototype.init = function () {
    var src = $(".marketplace-thumbnail-item.selected", this.$el).data(
      "img-viewer"
    );
    this.setImage(src);
  };

  PrintMarketplaceThumbnailView.prototype.toggleImageViewer = function (e) {
    var target = $(e.currentTarget);
    var src = target.data("img-viewer");

    //if it is 3D-view the user click on the 3D view
    if (src === "3D-view") {
      this.set3D();
    } else {
      this.setImage(src);
    }

    $(".marketplace-thumbnail-item", this.$el).removeClass("selected");
    target.addClass("selected");
  };

  PrintMarketplaceThumbnailView.prototype.setImage = function (src) {
    $("#Sculpteo3DViewerSelect").addClass("hidden");
    this.controller.updateViewerBG({ bgImage: src, set3d: false });
  };

  PrintMarketplaceThumbnailView.prototype.set3D = function () {
    $("#Sculpteo3DViewerSelect").removeClass("hidden");
    this.controller.updateViewerBG({ unsetBgImage: true, set3d: true });
  };
})((window.sculpteo = window.sculpteo || {}));
